<template>
  <suc-date-time-field
    :title="$t('pages.profile.tabs.personal_data.dni_expiration_data')"
    v-bind="$attrs"
    v-on="$listeners"
  ></suc-date-time-field>
</template>

<script>
import { SucDateTimeField } from "@/components/form";

export default {
  components: {
    SucDateTimeField,
  },
};
</script>

<style></style>
